import { Fragment } from 'react';
import { Box, Flex, Text } from '@mantine/core';
import { IconPencil } from '@tabler/icons-react';
import { Button } from 'src/design-system/Button';
import { FONT_WEIGHTS } from 'src/UI/theme/theme';

type Props = {
  participantNames: string[];
  onEdit?: () => void;
  onGenerate: () => void;
};

export function SuggestedActions({ participantNames, onEdit, onGenerate }: Props) {
  return (
    <Box>
      <Flex justify="space-between" align="center">
        <Text size="textXs" fw={FONT_WEIGHTS.semibold} c="black">
          Suggested actions
        </Text>
        {/* "Show all" dropdown hidden for now — re-enable once there are more suggested actions. */}
      </Flex>

      <Flex
        mt="xs"
        justify="space-between"
        align="center"
        gap="sm"
        bg="brand.1"
        px="md"
        py="sm"
        style={{ borderRadius: 20 }}
      >
        <Box style={{ minWidth: 0 }}>
          <Flex align="center" gap="xxxs">
            <Text size="textSm" fw={FONT_WEIGHTS.semibold} c="gray.10">
              Generate meeting note for{' '}
              {participantNames.length === 0
                ? 'this meeting'
                : participantNames.map((name, index) => (
                    <Fragment key={name}>
                      <Text
                        component="span"
                        size="textSm"
                        fw={FONT_WEIGHTS.semibold}
                        c="gray.10"
                        style={{ textDecoration: 'underline dotted', textUnderlineOffset: 2 }}
                      >
                        {name}
                      </Text>
                      {nameSeparator(index, participantNames.length)}
                    </Fragment>
                  ))}
            </Text>
            <IconPencil
              size={16}
              color="var(--mantine-color-gray-10)"
              style={{ cursor: 'pointer', flexShrink: 0 }}
              onClick={onEdit}
            />
          </Flex>
          <Text size="textXs" fw={FONT_WEIGHTS.medium} c="gray.10" mt="xxxs">
            Create a structured summary of the meeting.
          </Text>
        </Box>
        <Button
          variant="primary"
          h="auto"
          px="sm"
          py="xxs"
          fz="sm"
          fw={FONT_WEIGHTS.semibold}
          style={{ flexShrink: 0, borderRadius: 12 }}
          onClick={onGenerate}
        >
          Generate
        </Button>
      </Flex>
    </Box>
  );
}

function nameSeparator(index: number, length: number): string {
  if (index >= length - 1) return '';
  return index === length - 2 ? ' and ' : ', ';
}
